export class CookieInputs {
    hasAnyOtherSettings?:boolean;
    hasGoogleAnalytics?:boolean;
    hasGoogleAds?:boolean;
    backroundColor?:string;
    buttonColor?:string;
    buttonTextColor?:string;
    privacyPolicyUrl?:string;
}
